import type { SummaryAction } from '../../types';
import styles from './ActionCard.module.css';

interface Props {
  action: SummaryAction;
}

export default function SummaryCard({ action }: Props) {
  return (
    <div className={styles.card}>
      {action.title && <div className={styles.cardTitle}>{action.title}</div>}
      <div className={styles.metricGrid}>
        {action.metrics.map((metric, idx) => (
          <div key={idx} className={styles.metricItem}>
            <div className={styles.metricValue}>{metric.value}</div>
            <div className={styles.metricLabel}>{metric.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
